
import { Stack, Typography, Box } from "@mui/material";
import ColorCheckbox from "./colorCheckbox";


export default function ColorList({ items = [], selected = [], onToggle }) {
    return (
        <Stack spacing={0.75} sx={{ mt: 0.5 }}>
            {items.map((color) => {
                const isChecked = selected.includes(color.id);
                return (
                    <Box
                        key={color.id}
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "flex-start",
                            gap: 1,
                            cursor: "pointer",
                        }}
                        onClick={() => onToggle("colors", color.id)}
                    >
                        <ColorCheckbox
                            checked={isChecked}
                            color={color.hex}
                            onChange={() => onToggle("colors", color.id)}
                        />
                        <Typography
                            variant="body2"
                            sx={{
                                fontSize: "14px", 
                                fontWeight: 500, 
                                lineHeight: "120%", 
                                fontFamily: "Zen Maru Gothic",                                
                                textTransform: "uppercase",
                            }}
                        >
                            {color.name}
                        </Typography>
                    </Box>
                );
            })}
        </Stack>
    );
}
